module.exports = __webpack_public_path__ + "p3_img5.jpg?0a9fba322124f2d8557ab0da5e91ee88";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-imgs/p3/p3_img5.jpg
// module id = 107
// module chunks = 0